module.exports = __webpack_public_path__ + "img/help-circle.0405aab4.svg";